import React from "react";
import Grid from "@material-ui/core/Grid";
import arrowImg from "../../../images/link-arrow.png";
import phoneImg from "../../../images/icon-phone-black.png";
import ReactHtmlParser from "react-html-parser";
import Link from "../../Link";
import { GatsbyImage } from "gatsby-plugin-image";

export default function PubItem({ classes, pub }) {
  return (
    <Grid item xs={12} md={6} lg={4}>
      <div className={classes.Card}>
        <div className={classes.tags}></div>
        <div className={classes.CardUpper}>
          {pub.localFile && (
            <GatsbyImage
              image={pub.localFile?.childImageSharp?.gatsbyImageData}
              alt={pub.name}
              className={classes.CardImage}
            />
          )}
          {!pub.localFile && (
            <img
              src={pub.featuredImage}
              className={classes.CardImage}
              alt={pub.name}
            />
          )}
          <span className={classes.CardInfo}>
            {pub.facilityAccommodation && (
              <p className={classes.Tenancy}>Available</p>
            )}
          </span>
        </div>
        <div className={classes.CardBottom}>
          <h3 className={classes.CardName}>{ReactHtmlParser(pub.name)}</h3>
          <p className={classes.CardLocation}>{pub.displayLocation}</p>
          {pub.telephone && (
            <p className={classes.CardPhone}>
              <img src={phoneImg} alt="Phone" />
              <Link to={`tel:${pub.telephone}`}>{pub.telephone}</Link>
            </p>
          )}
        </div>
        {pub.hasOwnWebsite === true && (
          <Link to={pub.url} className={classes.CardLink}>
            View Pub
            <img src={arrowImg} alt="View Pub" />
          </Link>
        )}
        {pub.hasOwnWebsite !== true && (
          <Link to={"/pubs/" + pub.slug} className={classes.CardLink}>
            View Pub
            <img src={arrowImg} alt="View Pub" />
          </Link>
        )}
      </div>
    </Grid>
  );
}
